import { smoothScroll } from './utils/utils'
import Blazy from 'blazy'
import Flickity from 'flickity'
import inView from 'in-view'

const HTML = document.querySelector('html');

class App {

	constructor() {

		// Prevent scrollTop on click on a[href="#"] links
		let linksEmpty = document.querySelectorAll('a[href="#"]');
		if( linksEmpty ) linksEmpty.forEach((el) => { el.addEventListener('click', function(e) { e.preventDefault(); }) });

		// Smooth scroll for anchors link
		let linksAnchor = document.querySelectorAll('a[href*="#"]:not([href="#"])');
		if( linksAnchor ) linksAnchor.forEach((el) => { el.addEventListener('click', smoothScroll) });

		// Check if mac for better font aliasing
		if (navigator.platform === 'MacIntel' || navigator.platform === 'MacPPC') HTML.classList.add('is-mac')

		// Change logo color
		let logo = document.querySelector('.main-logo');
		let section = document.querySelectorAll('section')
		window.addEventListener('scroll', (e) => {
			let StopIteration = {};

			try {
			  section.forEach(function(s){
					let pos = s.getBoundingClientRect();
					logo.classList.remove('white');

					if( pos.top <= 0 && pos.bottom >= 0 && s.classList.contains('color--bg--blue-dark')) {
						logo.classList.add('white');
						throw StopIteration;
					}
			  });
			} catch(error) { if(error != StopIteration) throw error; }
		})

		// Flickity carousel
		let carousel = document.querySelectorAll('.carousel__slider');
		if( carousel ) {
			carousel.forEach((el) => {
				var flkty = new Flickity( el, {
				  cellAlign: 'left',
				  prevNextButtons: false,
				  contain: true
				});
			})
		}

		// Blazy
		this.blazy = new Blazy({
			breakpoints: [{
      	width: 420,
				src: 'data-src-small' 
     	}],
	    selector : '.js-lazy',
	    success : function(elt) {
	    	if( elt.closest('figure') )
	    		elt.closest('figure').classList.add('img-is-loaded')
	    }
		});


		inView.offset(window.innerHeight * .1);
		inView('.js-reveal:not(.is-visible)')
    	.on('enter', function(elt) { 
    		elt.classList.add('is-visible');

    		elt.dispatchEvent(new Event('inviewport'))
    	})

		return this
	}

	/**
	 * Init the page
	 * @return {object} The current instance
	 */
	init() {
		console.log(`${this.constructor.name} is init`)

		return this;
	}
}


window.addEventListener('load', function() {
	new App();
});